import { SliderCaptchaChallenge, ImageCaptchaResponse } from './type';

export const BOARD_HEIGHT = 150;
export const DEFAULT_PIECE_SIZE = 50;
export const HANDLE_SIZE = 58;
export const HANDLE_GAP = 1;

export function clamp(value: number, min: number, max: number) {
  return Math.min(Math.max(value, min), max);
}

export function adaptImageCaptchaToChallenge(data: ImageCaptchaResponse, boardWidth: number): SliderCaptchaChallenge {
  const rateLimit = boardWidth / 300;
  return {
    challengeId: data.captchaKey,
    backgroundUrl: data.backgroundImage,
    pieceUrl: data.puzzlePiece,
    pieceY: data.ycoordinate * rateLimit,
    pieceSize: data.pieceWidth * rateLimit,
    maxOffset: boardWidth - data.pieceWidth * rateLimit,
  };
}

export function getPuzzleOffset(sliderOffset: number, sliderMaxOffset: number, puzzleMaxOffset: number) {
  if (sliderMaxOffset <= 0) return 0;
  return (sliderOffset / sliderMaxOffset) * puzzleMaxOffset;
}

export function getSliderProgress(sliderOffset: number, trackWidth: number, handleWidth: number = HANDLE_SIZE) {
  if (trackWidth <= 0) return 0;
  return Math.min((sliderOffset + handleWidth) / trackWidth, 1);
}
